var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.927 25.9445L14.7591 25.9251C9.51514 25.2685 5.68709 20.6453 6.02018 15.3709C6.35327 10.0965 10.7325 5.99163 16.0174 6.00001C21.3023 6.00839 25.6686 10.1271 25.9849 15.4026C26.3013 20.678 22.4586 25.2891 17.2126 25.929L17.0777 25.9445L16.9826 24.9522L17.0942 24.9406C21.8193 24.3647 25.281 20.2121 24.9967 15.4605C24.7124 10.7088 20.7804 6.9985 16.0203 6.99012C11.2602 6.98175 7.31518 10.6782 7.0142 15.4288C6.71322 20.1794 10.1602 24.3442 14.8833 24.9367L15.0356 24.9542L14.927 25.9445Z",
    fill: "#F34041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.6859L16.3141 16L19.9987 12.315L19.6846 12.0009L16 15.6859L12.3141 12L12 12.3141L15.6859 16L12 19.6859L12.3141 20L16 16.3141L19.6859 20L20 19.6859Z",
    fill: "#F34041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureIcon);
export default __webpack_public_path__ + "static/media/FailureIcon.85ea8e500376172d52a978fee5464cc6.svg";
export { ForwardRef as ReactComponent };